var r=function(r){return r?r/10:0};export{r as getRemFromPx};
